module.exports = __webpack_public_path__ + "img/resume_profile.3209bf28.png";